let lang = 'en'
if (navigator.appVersion.indexOf('zh-CN') > -1) lang = 'zh'
if (navigator.appVersion.indexOf('en-US') > -1) lang = 'en'
if (navigator.appVersion.indexOf('km-KH') > -1) lang = 'km'

export const language = lang


export const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) { return pair[1] }
  }
  return (false);
}

